<template>
  <div>
    <vuetable ref="vuetable" :api-url="url" :httpOptions="options" :fields="fields" pagination-path="" @vuetable:pagination-data="onPaginationData"></vuetable>
    <div class="vuetable-pagination ui basic segment grid">
      <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      <bulma-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></bulma-pagination>
    </div>
  </div>
</template>


<script>
import moment from 'moment'

import Vuetable from 'vuetable-2/src/components/Vuetable'
import BulmaPagination from '../BulmaPagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'


export default {
  props: ["url"],
  components: {
    Vuetable, BulmaPagination, VuetablePaginationInfo
  },
  data() {
    return {
      isLoading: false,
      options: {
        headers: { 'Authorization': window.localStorage.getItem('biyadmin') },
      },
      fields: [
        // {
        //   name: '__sequence',   // <----
        //   title: '#',
        // },
        {
          name: 'firstName',
          title: 'First Name'
        },
        {
          name: 'lastName',
          title: 'Last Name'
        },
        {
          name: 'email',
          title: 'Email'
        },
             {
          name: 'phoneNumber',
          title: 'Phone'
        },
                     {
          name: 'isVerified',
          title: 'Verification status',
        },
                             {
          name: '_id',
          title: 'User ID',
        },
              {
          name: 'updatedAt',
          title: 'Date',
          callback: 'formatDate|DD/MMM HH:mm'
        },
      ]
    }
  },
  methods: {
    formatDate(value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value).format(fmt)
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    }
  }
}
</script>


// WEBPACK FOOTER //
// UsersTable.vue?2cf3fad3